import useViewContext from '/druid/internal/useViewContext';

export default function useScrollBarPercentage() {
  const { scrollBarPercentage } = useViewContext();

  return [scrollBarPercentage];
}
